import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SinisterTypeService } from '../../../../../services/table-management/sinisterType.service';
import { Rest } from '../../../../../../../rest/rest_client';
import { NotificationsService } from '../../../../../../../services/notifications-service/notifications.service';
import { I18nService } from '../../../../../../../services/i18n/i18n.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../../../../../../core/services/authentication/authentication.service';
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';


@Component({
  selector: 'app-sinister-type-form',
  templateUrl: './sinister-type-form.component.html',
  styleUrls: ['./sinister-type-form.component.css'],
  providers: [SinisterTypeService],
  standalone: false,
})
export class SinisterTypeFormComponent extends EntityFormComponent<Rest.InvSinisterType> implements OnInit {
  active: boolean;
  title: string;
  formManipulation: boolean;
  disableGranted: boolean;
  constructor(
    private sinisterTypeService: SinisterTypeService,
    notificationsService: NotificationsService,
    protected i18n: I18nService,
    private authenticationService: AuthenticationService,
    public translateService: TranslateService,
  ) {
    super(sinisterTypeService, notificationsService, i18n, authenticationService);
  }

  /**
   * Loads and evaluates all the necessary data before showing the form.
   *
   * @memberof AccessoryFormComponent
   */
  beforeShow() {
    this.active = !this.entity.disabled;

    if (this.isNew) {
      this.title = this.translateService.instant('tableManagement.sinister.createSinisterType');
    } else {
      this.title = this.translateService.instant('tableManagement.sinister.updateSinisterType');
    }

    this.setPermissions();
  }

  setPermissions() {
    const user = this.authenticationService.user;
    const rolesForForm = ['INV_SINISTER_TYPE_CREATE', 'INV_SINISTER_TYPE_UPDATE'];

    this.formManipulation = this.authenticationService.isOneRoleGranted(rolesForForm, user);
    this.disableGranted = this.authenticationService.isRoleGranted("INV_SINISTER_TYPE_DISABLE", user);

  }

}